<template>
  <div class="content">
    <div class="row" v-if="allowSearch">
      <div class="col-md-12 mb-2">
        <div class="input-group mb-1">
          <input ref="fldSearchText" type="text" class="form-control" v-model="searchText" placeholder="Filter Using Search Terms Here..." />
          <div class="input-group-append d-print-none" v-if="categories && categories.length">
            <select class="form-control" v-model="category" placeholder="Filter Using Categories Here....">
              <option></option>
              <option v-for="category in categories" :key="category.value" :value="category.value">{{ category.text }}</option>
            </select>
          </div>
          <div class="input-group-append d-print-none d-none d-md-block">
            <generic-toggle v-model="detailMode" label="Detail Mode" />
          </div>
        </div>
      </div>
    </div>
    <b-tabs v-model="tabsIndex">
      <b-tab :title="moduleTab.title" class="mt-1" v-for="moduleTab in moduleTabs" :key="moduleTab.title" :active="moduleTab.isActive">
        <div class="row" v-if="!detailMode">
          <div class="col-md-3 col-lg-2" v-for="module in moduleTab.modules" v-bind:key="module.id">
            <div class="card app-home-card">
              <router-link :to="module.to" :title="module.description" v-if="module.to">
                <a>
                  <div class="card-img-top">
                    <i class="fas" v-bind:class="module.icon"></i>
                  </div>
                  <div class="card-body">
                    <h5 class="card-title text-center" v-if="isHome">{{ module.moduleTitle }}</h5>
                    <h5 class="card-title text-center">{{ module.title }}</h5>
                  </div>
                </a>
              </router-link>
              <a v-bind:href="module.href" :title="module.description" :target="module.target" v-if="module.href">
                <div class="card-img-top">
                  <i class="fas" v-bind:class="module.icon"></i>
                </div>
                <div class="card-body">
                  <h5 class="card-title text-center" v-if="isHome">{{ module.moduleTitle }}</h5>
                  <h5 class="card-title text-center">{{ module.title }}</h5>
                </div>
              </a>
              <div class="card-footer" v-if="!module.isModule && !module.isLink">
                <button type="button" class="btn btn-success btn-sm" title="Add Favorite" @click="addFavorite(module.code, $event)" v-if="!module.isLink && !module.isModule && !module.isFavorite"><i class="fas fa-heart"></i></button>
                <button type="button" class="btn btn-danger btn-sm" title="Remove Favorite" @click="removeFavorite(module.code, $event)" v-if="!module.isLink && !module.isModule  && module.isFavorite"><i class="fas fa-trash"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="detailMode">
          <div class="col-md-12">
            <generic-table :items="moduleTab.modules" :fields="moduleTab.fields" hide-toolbar hide-pagination force-raw-table-mode>
              <template v-slot:cell(actions)="data">
                <div class="form-row">
                  <div class="col-lg-6 mx-0 pl-0 pr-0 pr-lg-1">
                    <router-link :to="data.item.to" v-if="data.item.to">
                      <a class="btn btn-sm btn-primary btn-block px-1">
                        <i class="fas" v-bind:class="data.item.icon"></i>
                      </a>
                    </router-link>
                    <a  class="btn btn-sm btn-primary btn-block px-1" v-bind:href="data.item.href" :target="data.item.target" v-if="data.item.href">
                      <i class="fas" v-bind:class="data.item.icon"></i>
                    </a>
                  </div>
                  <div class="col-lg-6 mx-0 px-0">
                    <button type="button" class="btn btn-success btn-sm btn-block" title="Add Favorite" @click="addFavorite(data.item.code, $event)" v-if="!data.item.isLink && !data.item.isModule && !data.item.isFavorite"><i class="fas fa-heart"></i></button>
                    <button type="button" class="btn btn-danger btn-sm btn-block" title="Remove Favorite" @click="removeFavorite(data.item.code, $event)" v-if="!data.item.isLink && !data.item.isModule  && data.item.isFavorite"><i class="fas fa-trash"></i></button>
                  </div>
                </div>
              </template>
            </generic-table>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
  export default {
    name: "generic-module-selector",
    props: {
      subFunctions: {
        type: Array,
        required: false,
        default() { return [ ]; }
      },
      allScreens: {
        type: Array,
        required: false,
        default() { return [ ]; }
      },
      links: {
        type: Array,
        required: false,
        default() { return [ ]; }
      },
      autoSort: {
        type: Boolean,
        default: true
      },
      allowSearch: {
        type: Boolean,
        default: true
      },
      ignoreFunctionLocks: {
        type: Boolean,
        default: false
      },
      mode: {
        type: String,
        default: 'Module'
      }
    },
    created() {
    },
    mounted() {
      if (this.allowSearch) {
        this.$refs.fldSearchText.focus();
      }
    },
    data() {
      return { 
        state: window.appState,
        searchText: '',
        tabsIndex: 0,
        category: '',
        categories: [ ],
        detailMode: appHelpers.landing.getDetailMode(),
        rawModuleFields: [
          { key: 'actions', label: 'Actions', sortable: false, class: ['d-print-none'] },
          { key: 'moduleTitle', label: 'Module', sortable: true, stickyColumn: true },
          { key: 'title', label: 'Title', sortable: true, stickyColumn: true },
          { key: 'description', label: 'Description', class: ['text-break', 'descriptionColumn'], sortable: true },
          { key: 'category1', label: 'Category 1', sortable: true },
          { key: 'category2', label: 'Category 2', sortable: true },
          { key: 'category3', label: 'Category 3', sortable: true },
        ],
        updateable: {
          favoriteFunctions: window.appState.favorites,
          screens: [ ],
          screensLoaded: false,
        },
      };
    },
    watch: {
      'searchText'() {
        this.searchTextChanged();
      },
      'detailMode'() {
        appHelpers.landing.setDetailMode(this.detailMode);
      },
    },
    computed: {
      isHome() {
        return (this.mode || 'Module').toLowerCase() === 'home';
        //return !this.links.length && (!this.subFunctions.length || this.subFunctions[0].functionType === 'Module');
      },
      isLink() {
        return (this.mode || 'Module').toLowerCase() === 'link';
        //return !!this.links.length;
      },
      isModule()
      {
        return (this.mode || 'Module').toLowerCase() === 'module';
      },
      moduleFields() {
        return this.rawModuleFields
          .filter((field) =>
            (field.key !== 'moduleTitle')
          );
      },
      allScreenFields() {
        return this.rawModuleFields;
      },
      favoriteFields() {
        return this.rawModuleFields
          .filter((field) =>
            (field.key !== 'moduleTitle' || this.isHome)
          );
      },
      moduleTabs() {
        let ret = [];
        for (let tabCtr = 0; tabCtr <= ((this.isHome && !this.isLink) ? 1 : 0); tabCtr++) {
          let functions = {
            title: tabCtr == 0 ? (this.isHome ? 'Modules' : (this.isLink ? 'Links' : 'Screens')) : 'All Screens',
            isFavorites: false,
            fields: tabCtr == 0 ? this.moduleFields : this.allScreenFields,
            modules: [ ],
            isActive: false,
          }
          let categoryIndex = { };
          let subFunctions = tabCtr == 0 ? this.subFunctions : this.allScreens;
          if (subFunctions && subFunctions.length) {
            this.massageFunctions(subFunctions).forEach((module) => {
              if (module.category1 && module.category1.length) {
                categoryIndex[module.category1.toUpperCase()] = module.category1;
              }
              if (module.category1 && module.category2.length) {
                categoryIndex[module.category2.toUpperCase()] = module.category2;
              }
              if (module.category1 && module.category3.length) {
                categoryIndex[module.category3.toUpperCase()] = module.category3;
              }
              functions.modules.push(module);
            });
          }
          if (tabCtr == (this.isLink ? 0 : 1) && this.links && this.links.length) {
            this.massageLinks(this.links).forEach((link) => {
              functions.modules.push(link);
            });
          }
          this.categories = [ ];
          Object.keys(categoryIndex).sort().forEach((categoryKey) => {
            this.categories.push({ value: categoryKey, text: categoryIndex[categoryKey] });
          });
          functions.modules = this.filterAndSortModules(functions.modules, this.searchText, this.category);
          
          ret.push(functions);
        }

        if (!this.isLink && !!this.updateable.favoriteFunctions.length) {
          let favorites = {
            title: 'Favorite Screens',
            isFavorites: true,
            fields: this.favoriteFields,
            modules: [ ],
            isActive: true,
          };
          if (this.updateable.favoriteFunctions && this.updateable.favoriteFunctions.length) {
            this.massageFunctions(this.updateable.favoriteFunctions).forEach((module) => {
              favorites.modules.push(module);
            });
          }
          favorites.modules = this.filterAndSortModules(favorites.modules, this.searchText, this.category);
          ret.push(favorites);
        }

        if (this.searchText && this.searchText.length) {
          this.tabsIndex = 0;

          for (let retIndex in ret) {
            if (ret[retIndex].modules && ret[retIndex].modules.length) {
              this.tabsIndex = parseInt(retIndex);
              break;
            }
          }
        }

        return ret;
      }
    },
    methods: {
      trimModuleOffScreenName(screenName) {
        return (screenName.indexOf(' - ') >= 0 ? screenName.substr(screenName.indexOf(' - ') + 3) : screenName);
      },
      getModuleFromScreenName(screenName) {
        return (screenName.indexOf(' - ') >= 0 ? screenName.substr(0, screenName.indexOf(' - ')) : '');
      },
      massageFunctions(subFunctions) {
        let modules = [];
        subFunctions.forEach((sf) => {
          let isModule = sf.functionType === 'Module';
          let isFavorite = !!this.updateable.favoriteFunctions.find((fave) => fave.code === sf.code);
          let moduleHref = (this.isHome && !isModule && sf.module && sf.module.url) ? (this.state.currentTenantId.toString() + sf.module.url) : this.state.currentTenantId.toString();
          let href = (this.isHome || isModule) ? (moduleHref + sf.url) : null;
          let to = (this.isHome || isModule) ? null : sf.url;
          modules.push ({
            title: isModule ? sf.title : this.trimModuleOffScreenName(sf.title),
            moduleTitle: isModule ? null : this.getModuleFromScreenName(sf.title),
            href: href,
            to: to,
            target: '',
            icon: sf.icon,
            code: sf.code,
            isModule: isModule,
            isLink: false,
            isFavorite: isFavorite,
            description: sf.description,
            category1: sf.category1,
            category2: sf.category2,
            category3: sf.category3,
          });
        });
        return modules;
      },
      massageLinks(links) {
        let modules = [];
        links.forEach((link, index) => {
          let icon = 'fa-bookmark';
          if (link.icon && link.icon.length) {
            if (link.icon.indexOf('fa-') !== 0) {
              icon = 'fa-' + link.icon;
            } else {
              icon = link.icon;
            }
          }
          modules.push({
            id: 'link-module-' + index,
            moduleTitle: 'Links',
            title: link.title,
            href: link.url,
            target: '_blank',
            icon: icon,
            isModule: false,
            isLink: true,
          });
        });
        return modules;
      },
      filterAndSortModules(modules, searchText, category) {
        let filteredModules = modules
          .filter((m) => !this.allowSearch || !searchText || !searchText.length 
            || (m.title || '').toUpperCase().indexOf(searchText.toUpperCase()) >= 0
            || (m.moduleTitle || '').toUpperCase().indexOf(searchText.toUpperCase()) >= 0
            || (this.detailMode && (m.description || '').toUpperCase().indexOf(searchText.toUpperCase()) >= 0)
          )
          .filter((m) => !this.allowSearch || !category || !category.length
            || (m.category1 || '').toUpperCase().indexOf(category.toUpperCase()) >= 0
            || (m.category2 || '').toUpperCase().indexOf(category.toUpperCase()) >= 0
            || (m.category3 || '').toUpperCase().indexOf(category.toUpperCase()) >= 0
          );
        if (this.autoSort) {
          filteredModules.sort((a, b) => {
            if (((a.moduleTitle || '') + ' - ' + (a.title || '')) !== ((b.moduleTitle || '') + ' - ' + (b.title || ''))) {
              return ((a.moduleTitle || '') + ' - ' + (a.title || '')) < ((b.moduleTitle || '') + ' - ' + (b.title || '')) ? -1 : 1;
            }
            return 0;
          });
        }
        return filteredModules;
      },
      addFavorite(functionCode, event) {
        if (event) {
          event.stopPropagation();
          event.preventDefault();
        }
        appHelpers.loader.start();

        if (!this.isHome) {
          this.updateable.screens = this.subFunctions;
        } else {
          this.updateable.screens = this.allScreens;
        }

        this.messages = [ ];
        return apiClient.user.addFunctionFavorite(this.state.userId, functionCode).then(() => {
          let functionData = this.updateable.screens.find((screen) => screen.code == functionCode);
          if (functionData) {
            this.updateable.favoriteFunctions.push(functionData);
          }
        }).catch(error => {
          this.messages = appHelpers.message.getFromResponse(error);
          return [];
        }).finally(() => {
          appHelpers.loader.stop();
        });
      },
      removeFavorite(functionCode, event) {
        if (event) {
          event.stopPropagation();
          event.preventDefault();
        }
        appHelpers.loader.start();

        this.messages = [ ];
        return apiClient.user.removeFunctionFavorite(this.state.userId, functionCode).then(() => {
          let functionDataIndex = this.updateable.favoriteFunctions.findIndex((screen) => screen.code === functionCode);
          if (functionDataIndex >= 0) {
            this.updateable.favoriteFunctions.splice(functionDataIndex, 1);
          }
        }).catch(error => {
          this.messages = appHelpers.message.getFromResponse(error);
        }).finally(() => {
          appHelpers.loader.stop();
        });
      },
      searchTextChanged() {
        //Placeholder
      },
    }
  };
</script>
<style type="text/css">
  .descriptionColumn
  {
    width: 45%;
  }
</style>